import Cers from "../../components/cers/Cers.vue"
export default {
  components: { Cers },
  data() {
    return {
      // 当前页面
      currentPage: 1,
      //每页的数据
      pageLen: 15,
      //课程的搜索名字
      classSearchName: '',
      //搜索学生的条件
      searchStudent: {
        name: '',
        company: '',
        phone: '',
      },
      //辨别是用条件搜索还是全部搜索学生=>默认全部
      searchType: true,
      // 当前选择课程的学员id
      studentId: '',
      //学生总数量
      studentTotal: 0,
      //学生搜素当前页
      studentSearchCurrentPage: 0,
      //学生当前页
      studentCurrentPage: 0,
      //个人的证书
      studentCer: [],
      //已经勾选了多个学生
      paruseStudent: [],
      //控制证书表单弹出框的显隐
      dialogFormVisible: false,
      //控制打印证书弹框
      dialogTabelVisible: false,
      //学生数据
      studnetData: [],
      //证书组件
      isCers: false,
      //传给组件的数组
      cerArr: [],
			moreChooseCersLoading:false,
			// 控制身份证批量下载学士证明弹窗
			showIdcardDown:false,
			idcards:'',
			idList:[]
    }
  },
  methods: {
    // ttt() {
    //   // // console.log(this.studentCer);
    //   // console.log(this.cerArr);
    // },

    //查看学时证明
    checkCer(obj) {
      //置空证书数组
      this.studentCer = [];
      //弹出证书弹框
      this.dialogFormVisible = true;
      //查看证书接口发送的数据
      let data = {
        owner_id: obj.id,
        token: this.$store.state.authority_management,
        length: 999,
        offset: 0
      }
      //发送请求查看证书
      this.$post("cers/shop_search", data).then(res => {
        //若存在证书，则循环存进证书数据
        if (res.data.result.data.length > 0) {
          for (let val of res.data.result.data) {
            let obj = {
              date: val.cer_year,
              pay_date: val.pay_date,
              products: []
            };
            this.studentCer.push(obj);
            //因为返回每一项证书订单项为一个JSON字符串 => 【1，3，4】
            //需要再循环请求拿到证书的产品回来
            for (let v of JSON.parse(val.purchased_id)) {
              //获取id获取订单项发送给后台的数据
              let data2 = {
                id: v,
                token: this.$store.state.authority_management
              }
              //获取id获取订单项发送给后台的接口
              this.$post("purchased/get", data2).then(res => {
                //拿到产品把多个产品添加到证书对象的产品数组属性里面
                obj.products.push(res.data.result);
              })
            }
          }
        }

      })
    },
    //该页每页要的数组
    handleSizeChange(val) {
      this.pageLen = val;
      this.getAllStudent();
    },
    //确定搜索学生
    confirmSearch() {
      this.searchType = false;
      let obj = {
        token: this.$store.state.authority_management,
        company: this.searchStudent.company,
        name: this.searchStudent.name,
        phone: this.searchStudent.phone,
        offset: 0,
        length: this.pageLen
      };
      this.$post('users/search', obj).then(res => {
        this.studnetData = res.data.result.data;
        this.studentTotal = res.data.result.total;
      })
    },
    //点击学员多选框
    handleStudentChange(val) {
      let arr = [];
      for (let item of val) {
        arr.push(item.id);
      }
      this.paruseStudent = arr;
    },

    //点击当前页面获取该有的信息
    getClassPage(currentPage) {
      this.classCurrentPage = (currentPage - 1) * 15;
      this.allClass(this.studentId);
    },
    //获取所有学生的信息
    getAllStudent() {
      this.searchType = true;
      this.$post('users/search', { token: this.$store.state.authority_management, offset: this.studentCurrentPage, length: this.pageLen, shop_id: this.$store.state.store.id }).then(res => {
        this.studentTotal = res.data.result.total;
        this.studnetData = res.data.result.data;
      })
    },
    //根据分页获取学生信息
    getStudentPage(currentPage) {
      this.currentPage = currentPage;
      if (this.searchType) {
        //根据点击的分页改变数据的偏移量
        this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
        //再请求对应的学生信息
        this.getAllStudent();
      } else {
        this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
        this.confirmSearch()
      }

    },
    //批量下载学时证明
    moreChooseCers() {
			this.moreChooseCersLoading = true
			this.paruseStudent.forEach(id => {
				this.$post('purchased/get_image', {
					user_id: id,
					token: this.$store.state.authority_management
				}).then(res => {
					// // console.log(res)
					if (res.status === 200) {
						// certificate
						this.certificate = res.data.result
						// // console.log(this.certificate)
						for (let i = 0; i < this.certificate.length; i++) {
							// this.createPicture()
							// this.downloadIamge(this.baseUrl + this.certificate[i], '学时证明')
							let downImage = this.baseUrl + this.certificate[i]
							var alink = document.createElement("a");
							alink.href = downImage;
							alink.download = res+'.'+i; //图片名
							alink.click()
							
						}
						this.moreChooseCersLoading = false
					}
					
				})
				
			})
    },
    //下载个人学时证明
    downCer(id) {
      // // console.log(id)
      this.$post('purchased/get_image', {
      	user_id: id,
      	token: this.$store.state.authority_management
      }).then(res => {
      	// // console.log(res)
      	if(res.data.result.length == 0){
      		this.$message({
      			type:"error",
      			message:"该用户没有已完成证书"
      		})
      	}else if(res.data.result == "用户订单丢失"){
      		this.$message({
      			type:"error",
      			message:"该用户订单丢失"
      		})
      		return false
      	}
      	
      	if (res.status === 200) {
      		// certificate
      		this.certificate = res.data.result
      		// // console.log(this.certificate)
      		for (let i = 0; i < this.certificate.length; i++) {
      			// this.createPicture()
      			// this.downloadIamge(this.baseUrl + this.certificate[i], '学时证明')
      			let downImage = this.baseUrl + this.certificate[i]
      			var alink = document.createElement("a");
      			alink.href = downImage;
      			alink.download = alink.download = res+'.'+i; //图片名
      			alink.click()
						
      		}
      	}
      	
      })
    },
		// 身份证批量下载学士证明
		showIdcardDownDialog(){
			this.showIdcardDown = true
		},
		// 身份证批量下载学生证明
		generateProveData() {
		  // this.showIdcard = false
		  if (this.idcards.trim() === '') {
		    this.$message({
		      type: 'error',
		      message: '最少输入一个身份证号'
		    })
		    return
		  }
		  let idcard_arr = this.idcards.trim().split('\n')
		
		  // 检查输入的身份证是否有误
		  // for (let i = 0; i < idcard_arr.length; i++) {
		  //   this.getUserByIdcard(idcard_arr[i])
		  //   if (this.flag === 0) {
		  //     break
		  //   }
		  // }
		
		  // 根据身份证号获取id
		  this.getIdByIdcard(idcard_arr)
		},
		// 根据身份证号数组获取id数组
		getIdByIdcard(idcard_arr) {
		  this.$post('users/idcard_arr_id', {
		    token: this.$store.state.authority_management,
		    offset: 0,
		    length: 9999,
		    idcard_arr: JSON.stringify(idcard_arr)
		  }).then(res => {
		    // // console.log(res)
		    if (res.data.result.total !== idcard_arr.length) {
		      this.$message({
		        type: 'error',
		        message: '您输入的身份证信息有误, 请重新输入'
		      })
		      return
		    }
		    let list = res.data.result.data
		    list.map(i => {
		      this.idList.push(i.id * 1)
		    })
		    this.idList.map(id => {
		      // this.createCers(i)
					this.$post('purchased/get_image', {
						user_id: id,
						token: this.$store.state.authority_management
					}).then(res => {
						// // console.log(res)
						if (res.status === 200) {
							// certificate
							this.certificate = res.data.result
							// // console.log(this.certificate)
							for (let i = 0; i < this.certificate.length; i++) {
								// this.createPicture()
								// this.downloadIamge(this.baseUrl + this.certificate[i], '学时证明')
								let downImage = this.baseUrl + this.certificate[i]
								var alink = document.createElement("a");
								alink.href = downImage;
								alink.download = res+'.'+i; //图片名
								alink.click()
								
							}
							this.showIdcardDown = false
						}
						
					})
		    })
		    this.idcards = ''
		  })
		},
		// 身份证批量下载取消按钮
		colseGenerateProve() {
		  this.showIdcard = false
		  this.idcards = ''
		},

  },
  created() {
    this.getAllStudent();
  }

}
